<template>
  <div
    style="font-size:12px; margin-top:10px;"
    v-if="!question.relation_section"
  >
    <b-checkbox true-value="1" false-value="0" v-model="question.optional">{{
      $t("question.choix.optional")
    }}</b-checkbox>
    <br />
    <b-checkbox
    @change.native="propsToParentAutre()"
      @change="toggleAutre()"
      v-if="
        elementTypeQuestion == 'radio' ||
          elementTypeQuestion == 'checkboxes' ||
          elementTypeQuestion == 'select'
      "
      true-value=1
      false-value=0
      v-model="question.autre"
      >{{ $t("question.choix.autre") }}</b-checkbox
    >
  </div>
</template>

<script>
import EventBus from '@/eventBus'
export default {
  name: 'OptionFacultative',
  props: {
    question: Object,
    elementTypeQuestion: String
  },
  methods: {
    propsToParentAutre () {
      EventBus.$emit('update_question')
      this.$emit('checked', this.question.autre)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/components/OptionFacultative.vue